<div class="c-contenedor">
    <div class="row">
        <div class="col-12 p-0">
            <img class="icon-close pr-10" (click)="onCloseClick()" src="assets/icons/ico-close.png" alt="cerrar">
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <p class="descripcion-principal">Ingresa tus datos para continuar con la solicitud</p>
            <form [formGroup]="dataPersonaNaturalRetoma" (ngSubmit)="Continuar($event)">
                <div class="persona-natural">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="row">
                                <div class="col-md-12 txt-rut">
                                    <label for="txtRut" class="mb-0">RUT</label>
                                    <input tabindex="2" appFormatRut
                                        [ngClass]="{
                                        inputValido: rutControl.valid,
                                        inputInvalido: (rutControl.invalid && rutControl.touched) || (rutControl.invalid && rutControl.dirty) }"
                                        type="text" name="txtRut" formControlName="txtRut" placeholder="Ej: 123456789"
                                        autocomplete="isDevMode()" (focusout)="checkInput('txtRut')" />
                                    <div *ngFor="let validation of messageRescatarDataError.txtRut">
                                        <p *ngIf="rutControl.hasError(validation.type) && (rutControl.dirty || rutControl.touched)"
                                            class="mensajeError mb-0">
                                            {{ validation.message }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="row numero-serie">
                                <div class="col-md-12 numero-serie">
                                    <label for="numeroSerie" class="mb-0">Número de serie o documento de tu
                                        cédula</label>
                                    <input tabindex="3" appFormatSerie
                                    [ngClass]="{inputValido: serieControl.valid,inputInvalido:(serieControl.invalid && serieControl.touched) ||(serieControl.invalid && serieControl.dirty)}"
                                    type="text" id="txtSerie" name="txtSerie" formControlName="txtSerie" placeholder="Ej: 100000001" autocomplete="isDevMode()" (focusout)="checkInput('txtSerie')" />
                                    <div *ngFor="let validation of messageRescatarDataError.txtSerie">
                                        <p *ngIf="
                                serieControl.hasError(validation.type) &&
                                (serieControl.dirty || serieControl.touched)
                              " class="mensajeError mb-0">
                                            {{ validation.message }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <app-carrusel-cedula></app-carrusel-cedula>
                        </div>
                    </div>
                    <div class="row">
                       <!--  <div class="col-md-12 terminos-condiciones">
                            <mat-checkbox [disabled]="rutControl.invalid || serieControl.invalid" tabindex="4"
                                formControlName="autorizacion">
                                He leído y acepto los <a href="{{urlTerminos}}" rel="noopener noreferrer"
                                    target="_blank">Términos y
                                    condiciones</a> de Transbank.
                            </mat-checkbox>
                            <mat-checkbox [disabled]="rutControl.invalid || serieControl.invalid" tabindex="4"
                                formControlName="autorizacion2">
                                He leído y acepto la <a href="{{urlPrivacidad}}" rel="noopener noreferrer"
                                    target="_blank">Política de
                                    privacidad</a> y autorizo a Transbank a hacer tratamiento de mis datos personales de
                                acuerdo a la Ley
                                vigente.
                            </mat-checkbox>
                        </div> -->
                    </div>
                    <div class="row">
                        <div *ngIf="authControl.dirty && !authControl.valid || authControl2.dirty && !authControl2.valid"
                            class="col-md-12 box-mensaje-error">
                            <app-messages class="error mt-16"
                                [message]="'Acepta la autorización de validación de tus datos para continuar'"></app-messages>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <button tabindex="5" class="btn-primary-tbk" type="submit" value="Continuar"
                                [disabled]="rutControl.invalid || serieControl.invalid">
                                <div *ngIf="loading" class="spinner-border text-light" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                                <div *ngIf="!loading">Continuar</div>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>